import produce from "immer";
import React, { FC, useMemo } from "react";
import { TableCellValue, TableColumn } from "src/requests/table/types";
import { ValueFormat } from "src/requests/templates/types";
import {
  FlowioTableCellInput,
  FlowioTableCellInputProps,
} from "../FlowioInput";
import { ClearIcon, EntityContainer } from "./styles";

type Props = {
  value: number | null;
  editable: boolean;
  isEdit: boolean;
  handleEdit(newCellVal: TableCellValue): void;
  handleDelete(): void;
} & Omit<FlowioTableCellInputProps, "value" | "onChange">;

const SingleTableCellInput: FC<Props> = ({
  handleDelete,
  isEdit,
  handleEdit,
  format,
  column,
  ...rest
}) => {
  const getModifiedFormat = (): ValueFormat =>
    produce(format, (draft) => {
      draft.general.required = true;
      draft.typeSpecific.select = { displayAsSearchSelect: true };
    });

  const modifiedFormat = useMemo(getModifiedFormat, [format]);

  return (
    <EntityContainer edit={isEdit}>
      <FlowioTableCellInput
        {...rest}
        onChange={handleEdit}
        format={modifiedFormat}
        column={{ ...column, isArray: false }}
      />
      {isEdit && <ClearIcon onClick={handleDelete} />}
    </EntityContainer>
  );
};

export default SingleTableCellInput;
